import { useEffect } from 'react';
import PageNav from 'Components/PageNav/PageNav';
import { InfoBlock } from 'Components/Order/InfoBlock/InfoBlock';
import { Locations } from 'Components/Order/Locations/Locations';
import { Order } from 'Components/Order/Order';
import { Broker } from 'Components/Broker/Broker';
import { OrderCalc } from 'Components/OrderCalc/OrderCalc';
import { Driver } from 'Components/Driver/Driver';
import { PreviousOrders } from 'Components/PreviousOrders/PreviousOrders';
import { Weather } from 'Components/Weather/Weather';
import { useAppDispatch } from 'Redux/store';
import { getOrder } from 'Redux/Order/reducer';
import { useParams } from 'react-router-dom';
import styles from './OrderDetails.module.scss';

export const OrderDetails = () => {
  const params = useParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (params.id) {
      const orderID = parseInt(params.id, 10);

      window.scrollTo({ top: 0 });

      dispatch(getOrder(orderID));
    }
  }, [params.id, dispatch]);

  return (
    <div className={styles.orderDetails}>
      <PageNav content="Loadboard" />

      <div className={styles.orderDetails__firstColumn}>
        <Order>
          <Locations />
          <InfoBlock />
        </Order>

        <Broker />
      </div>

      <div className={styles.orderDetails__secondColumn}>
        <OrderCalc />
      </div>

      <div className={styles.orderDetails__thirdColumn}>
        <Driver />

        <PreviousOrders />

        <Weather />
      </div>
    </div>
  );
};
